import {
  Box,
  Button,
  Container,

  Input,
  Menu,
  Select,
  Tabs,
  Text,
  UnstyledButton,
} from "@mantine/core";
import { LuChevronDown, LuFileText, LuPlus } from "react-icons/lu";
import DraftNotesTab from "../../../components/DraftNotesTab";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import NoteTable from "../../../components/NoteTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { getAllFacilitiesModal, getAllFacilityTypes } from "../../../services";
import { getAllNoteTypes, getNotes } from "../../../services/note";
import { getAllStaff } from "../../../services/staff";
import useDebounce from "../../../utils/useDebounce";
import moment from "moment";
import { DatePickerInput } from "@mantine/dates";
import useStyles from "./clientNoteViewStyle";
import AddEssentialNote from "../../../components/AddEssentialNote/AddEssentialNote";
import { Billing_Services_Note, Essential_Support_Note } from "../../../http";
import NoteDrawer from "../../../components/NoteModal/NewNoteDesignCopy";
import { RxCross2 } from "react-icons/rx";
import { IoChevronBack, IoFilter } from "react-icons/io5";
import { IconSearch } from "@tabler/icons-react";
import NoteModalNew from "../../../components/NoteModal/NoteModalNew";
import UsePreviousNoteDrawer from "../../../components/UsePreviousNoteDrawer";

const ClientNoteview = ({ userId, activeTab }) => {
  const { classes } = useStyles();

  const [data, setData] = useState(null);
  const [view, setView] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [noteType, setNoteType] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { notes, loading } = useSelector((state) => state?.note);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [oneDayValue, setOneDayValue] = useState(null);
  const [billingServices, setBillingServices] = useState("");
  const [progressNoteState, setProgressNoteState] = useState("");
  const [isViewNoteOpen, setIsViewNoteOpen] = useState(false);
  // Plain "View" keeps Approve/Reject hidden (existing behavior); the
  // kebab's own Approve/Reject items open this same drawer with them shown.
  const [hideApproveReject, setHideApproveReject] = useState(true);
  const [isFromDraft, setIsFromDraft] = useState(false);
  const [saveAsNewNote, setSaveAsNewNote] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [newNoteMenuOpen, setNewNoteMenuOpen] = useState(false);
  const [prevNoteOpened, setPrevNoteOpened] = useState(false);
  const [sortField, setSortField] = useState("noteDate");
  const [sortOrder, setSortOrder] = useState("descending");
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 2000);

  const [activeFilters, setActiveFilters] = useState({
    facility: null,
    createdBy: null,
    noteTypeFilter: null,
    client: null,
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tempFacility, setTempFacility] = useState(null);
  const [tempCreatedBy, setTempCreatedBy] = useState(null);
  const [tempNoteType, setTempNoteType] = useState(null);

  const { allDeletedFacilities } = useSelector((state) => state?.facility);
  const { allStaff } = useSelector((state) => state?.staff);
  const { allNotesTypes } = useSelector((state) => state?.note);
  const { allPatients } = useSelector((state) => state?.patient);
  const hasActiveFilters =
    activeFilters?.facility ||
    activeFilters?.createdBy ||
    activeFilters?.noteTypeFilter ||
    activeFilters?.client ||
    dateRange;

  useEffect(() => {
    getAllNoteTypes();
    getAllFacilityTypes();
    // getAllPatientsModal();
    getAllFacilitiesModal("all");
  }, []);

  useEffect(() => {
    if (activeTab === "notes") {
      getAllStaff("all");
    }
  }, [activeTab]);

  // This component stays mounted while switching between the client's tabs
  // (Tabs.Panel content isn't unmounted on tab change). Clear filters as soon
  // as the user leaves the "notes" tab for another tab (MAR, CarePlan,
  // Profile, etc.) so returning to Notes later starts unfiltered.
  const isFirstActiveTabRender = useRef(true);
  useEffect(() => {
    if (isFirstActiveTabRender.current) {
      isFirstActiveTabRender.current = false;
      return;
    }
    if (activeTab !== "notes") {
      handleResetAllFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // useEffect(() => {
  //   getNotes(currentPage, userId, true, dateRange, sortField, sortOrder);
  // }, [currentPage, dateRange]);
  useEffect(() => {
    setCurrentPage(1);
    getNotes(1, userId, true, dateRange, sortField, sortOrder, debouncedSearch || undefined, activeFilters);
  }, [debouncedSearch]);

  useEffect(() => {
    getNotes(currentPage, userId, true, dateRange, sortField, sortOrder, debouncedSearch || undefined, activeFilters);
  }, [currentPage, dateRange, activeFilters]);

  const handleDateRange = (dates) => {
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };

  // const handleCreatedAt = (date) => {
  //   let startDate = moment(dateRangeVal[0]);
  //   setCreatedAt()
  // };

  const handleSaveDateRange = () => {
    if (dateRangeVal?.length) {
      let startDate = moment(dateRangeVal[0]).startOf("day");
      let endDate = moment(dateRangeVal[1]).endOf("day");
      setDateRange([startDate, endDate]);
    } else if (oneDayValue) {
      let startDate = moment(oneDayValue).startOf("day");
      let endDate = moment(oneDayValue).endOf("day");
      setDateRange([startDate, endDate]);
    }
    setDropdownOpen(false);
  };

  const handleCancelDateRange = () => {
    setDateRangeVal([]);
    setDateRange(null);
    setDropdownOpen(false);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSortChange = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  // const handleAddEssential = () => {
  //   setNoteType(Essential_Support_Note);
  //   setOpen(true);
  // };

  const getFacilityName = (id) => {
    const fac = allDeletedFacilities?.facilities?.find((f) => f.id === id);
    return fac?.name || id;
  };

  const getStaffName = (id) => {
    const staff = allStaff?.find((s) => s?.id === id);
    return (
      staff?.name ||
      `${staff?.firstName || ""} ${staff?.lastName || ""}`.trim() ||
      id
    );
  };

  const getNoteTypeName = (id) => {
    const nt = allNotesTypes?.ntypes?.find((n) => n?.id === id);
    return nt?.name || id;
  };

  const getClientName = (id) => {
    const patient = allPatients?.find((p) => p?.id === id);
    return patient?.name || id;
  };

  const handleApplyFilter = () => {
    const newFilters = { ...activeFilters };
    if (selectedCategory === "facility" && tempFacility) {
      newFilters.facility = tempFacility;
    }
    if (selectedCategory === "staff" && tempCreatedBy) {
      newFilters.createdBy = tempCreatedBy;
    }
    if (selectedCategory === "noteType" && tempNoteType) {
      newFilters.noteTypeFilter = tempNoteType;
    }
    // if (selectedCategory === "client" && tempClient) {
    //   newFilters.client = tempClient;
    // }
    if (selectedCategory === "date") {
      handleSaveDateRange();
    }
    setActiveFilters(newFilters);
    setCurrentPage(1);
    setDropdownOpen(false);
    setSelectedCategory(null);
  };

  const handleResetAllFilters = () => {
    setActiveFilters({
      facility: null,
      createdBy: null,
      noteTypeFilter: null,
      // client: null,
    });
    setDateRange(null);
    setDateRangeVal([]);
    setOneDayValue(null);
    setTempFacility(null);
    setTempCreatedBy(null);
    setTempNoteType(null);
    // setTempClient(null);
    setSelectedCategory(null);
    setCurrentPage(1);
    setDropdownOpen(false);
  };

  const handleRemoveFilter = (key) => {
    if (key === "date") {
      setDateRange(null);
      setDateRangeVal([]);
      setOneDayValue(null);
      setCurrentPage(1);
    } else {
      setActiveFilters((prev) => ({ ...prev, [key]: null }));
      setCurrentPage(1);
    }
  };

  const handleAddEssential = () => {
    if (billingServices) {
      setNoteType(Billing_Services_Note);
    } else {
      setNoteType(Essential_Support_Note);
    }
    setOpen(true);
  };

  const handleEditDraft = (draft) => {
    setNoteType(draft.noteType?._id || draft.noteType);
    setIsFromDraft(true);
    setOpen(true);
  };

  // Same "duplicate as new note" flow as the standalone Notes module's
  // handleDuplicateNote — saveAsNew keeps NewNoteDesignCopy's Client/Facility
  // fields locked to this client profile (userId is always set here) while
  // still creating a brand-new note instead of updating the source one.
  const handleDuplicateNote = (row) => {
    getAllStaff("all");
    setData(row);
    setSaveAsNewNote(true);
    setOpen(true);
  };

  const refetchNotes = () => {
    getNotes(currentPage, userId, true, dateRange, sortField, sortOrder, debouncedSearch || undefined, activeFilters);
  };

  // Open a draft in the read-only view drawer (NoteModalNew), shown with a
  // "Draft" status — same as the standalone Notes module. A draft isn't a Note
  // document (its content lives in `formState`, its type is a populated
  // object), so reshape it into the { fields, noteId, descriptions, ... } form
  // a submitted note has.
  const openDraftView = (draft) => {
    const typeId = draft.noteType?._id || draft.noteType;
    const noteLike = {
      ...(draft.formState || {}),
      _id: draft._id,
      id: draft._id,
      noteId: { id: String(typeId), _id: typeId, name: draft.noteType?.name },
      approvalStatus: "draft",
      isDraft: true,
      createdAt: draft.createdAt,
      updatedAt: draft.updatedAt,
    };
    setView(true);
    setData(noteLike);
    setIsViewNoteOpen(true);
  };

  return (
    <Container fluid className={classes.content} px={20}>
      {/* Note Modal */}
      <AddEssentialNote
        openModal={openModal}
        setOpenModal={setOpenModal}
        onConfirm={handleAddEssential}
        billingServices={billingServices}
        setBillingServices={setBillingServices}
      />
      <NoteDrawer
        close={() => {
          setOpen(false);
          setData(null);
          setNoteType(null);
          setIsFromDraft(false);
          setSaveAsNewNote(false);
        }}
        // view={view}
        data={data}
        userId={userId}
        isClientView={true}
        opened={isopen}
        viewOpened={isViewNoteOpen}
        setView={setView}
        noteType={noteType}
        autoRestoreDraft={isFromDraft}
        title={"Add New Note"}
        setOpenModal={setOpenModal}
        setBillingServices={setBillingServices}
        setProgressNoteState={setProgressNoteState}
        progressNoteState={progressNoteState}
        currentPage={currentPage}
        dateRange={dateRange}
        activeFilters={activeFilters}
        saveAsNew={saveAsNewNote}
      />
      <NoteModalNew
        opened={isViewNoteOpen}
        close={() => {
          setIsViewNoteOpen(false);
          setData(null);
        }}
        hideApproveRejectButtons={hideApproveReject}
        onApprovalChanged={refetchNotes}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />
      <UsePreviousNoteDrawer
        opened={prevNoteOpened}
        close={() => setPrevNoteOpened(false)}
        userId={userId}
        onUseNote={(sourceNote) => {
          // Reuse the picked note as a template. isClientView + userId (always
          // set here) keep the Client/Facility locked to this client's profile,
          // and saveAsNew creates a brand-new note instead of editing the source.
          setPrevNoteOpened(false);
          getAllStaff("all");
          setData(sourceNote);
          setSaveAsNewNote(true);
          setOpen(true);
        }}
      />

      {/* Filter and Add Button */}
      <Tabs defaultValue="all-notes" styles={{ tab: { "&[data-active]": { borderColor: "var(--app-text)", color: "var(--app-text)" } } }}>
      <Box className={classes.btn}>
        <Tabs.List>
          <Tabs.Tab value="all-notes">All Notes</Tabs.Tab>
          {/* <Tabs.Tab value="drafts">Saved Drafts</Tabs.Tab> */}
        </Tabs.List>
        <Box className={classes.rightBTN}>
          <Menu
            width={Math.min(350, window.innerWidth - 24)}
            shadow="md"
            radius={"md"}
            opened={dropdownOpen}
            position="bottom-end"
            onClose={() => {
              setDropdownOpen(false);
              setSelectedCategory(null);
            }}
          >
            <Menu.Target title="Filter">
              <Button
                size="md"
                radius="md"
                title="Filter"
                leftIcon={<IoFilter />}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                color="gray"
                variant="outline"
              >
                Filter
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              {!selectedCategory ? (
                <>
                  <Box className={classes.box_header}>
                    <Text size="lg" weight={500}>
                      Filter
                    </Text>
                    <Button
                      variant="unstyled"
                      p={0}
                      onClick={() => setDropdownOpen(false)}
                    >
                      <RxCross2 />
                    </Button>
                  </Box>
                  <Box className={classes.filterCategoryList}>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("facility");
                        setTempFacility(activeFilters.facility);
                      }}
                    >
                      <Text>Facility</Text>
                      {activeFilters.facility && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("staff");
                        setTempCreatedBy(activeFilters.createdBy);
                      }}
                    >
                      <Text>Staff Name</Text>
                      {activeFilters.createdBy && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => {
                        setSelectedCategory("noteType");
                        setTempNoteType(activeFilters.noteTypeFilter);
                      }}
                    >
                      <Text>Note Type</Text>
                      {activeFilters.noteTypeFilter && (
                        <Box className={classes.activeFilterDot} />
                      )}
                    </Box>
                    <Box
                      className={classes.filterCategoryItem}
                      onClick={() => setSelectedCategory("date")}
                    >
                      <Text>Date</Text>
                      {dateRange && <Box className={classes.activeFilterDot} />}
                    </Box>
                  </Box>
                  <Box className={classes.btn_container}>
                    <Button
                      size="sm"
                      radius={"md"}
                      color="gray"
                      variant="outline"
                      onClick={handleResetAllFilters}
                    >
                      Reset All
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    className={classes.filterCategoryHeader}
                    onClick={() => setSelectedCategory(null)}
                  >
                    <IoChevronBack size={16} />
                    <Text weight={600}>
                      {selectedCategory === "facility" && "Facility"}
                      {selectedCategory === "staff" && "Staff Name"}
                      {selectedCategory === "noteType" && "Note Type"}
                      {selectedCategory === "date" && "Date"}
                    </Text>
                  </Box>
                  <Box className={classes.box_body}>
                    {selectedCategory === "facility" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Facility"
                          placeholder="Search facility..."
                          searchable
                          clearable
                          value={tempFacility}
                          onChange={setTempFacility}
                          data={
                            allDeletedFacilities?.facilities
                              ?.filter(
                                (p) =>
                                  p?.active === true && p?.deleted === false,
                              )
                              ?.map((f) => ({
                                label: f?.name,
                                value: f?.id,
                              })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "staff" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Staff"
                          placeholder="Search staff..."
                          searchable
                          clearable
                          value={tempCreatedBy}
                          onChange={setTempCreatedBy}
                          data={
                            allStaff
                              ?.filter(
                                (p) =>
                                  p?.active === true && p?.deleted === false,
                              )
                              ?.map((s) => ({
                                label:
                                  s?.name ||
                                  `${s?.firstName || ""} ${s?.lastName || ""}`.trim(),
                                value: s?.id,
                              })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "noteType" && (
                      <Box className={classes.filterFields}>
                        <Select
                          label="Select Note Type"
                          placeholder="Search note type..."
                          searchable
                          clearable
                          value={tempNoteType}
                          onChange={setTempNoteType}
                          data={
                            allNotesTypes?.ntypes?.map((n) => ({
                              label: n?.name,
                              value: n?.id,
                            })) || []
                          }
                        />
                      </Box>
                    )}
                    {selectedCategory === "date" && (
                      <>
                        <Box className={classes.filterFields}>
                          <DatePickerInput
                            size="sm"
                            radius={"md"}
                            clearable
                            type="range"
                            value={dateRangeVal}
                            disabled={oneDayValue}
                            label="Select Date Range"
                            onChange={handleDateRange}
                            placeholder="Select Date Range"
                          />
                        </Box>
                        <Box className={classes.filterFields}>
                          <DatePickerInput
                            radius={"md"}
                            clearable
                            size="sm"
                            value={oneDayValue}
                            label="Select Date"
                            placeholder="Select Date"
                            onChange={handleDateChange}
                            disabled={dateRangeVal?.length}
                          />
                        </Box>
                      </>
                    )}
                  </Box>
                  <Box className={classes.btn_container}>
                    <Button
                      size="sm"
                      radius={"md"}
                      color="gray"
                      variant="outline"
                      onClick={() => {
                        if (selectedCategory === "facility")
                          setTempFacility(null);
                        // if (selectedCategory === "client") setTempClient(null);
                        if (selectedCategory === "staff")
                          setTempCreatedBy(null);
                        if (selectedCategory === "noteType")
                          setTempNoteType(null);
                        if (selectedCategory === "date") {
                          setDateRangeVal([]);
                          setOneDayValue(null);
                        }
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      radius={"md"}
                      size="sm"
                      disabled={loading}
                      onClick={handleApplyFilter}
                      style={{
                        backgroundColor: "var(--app-primary)",
                      }}
                    >
                      Apply
                    </Button>
                  </Box>
                </>
              )}
            </Menu.Dropdown>
          </Menu>
          <Menu
            width={300}
            shadow="md"
            radius="md"
            position="bottom-end"
            withinPortal
            opened={newNoteMenuOpen}
            onClose={() => setNewNoteMenuOpen(false)}
          >
            <Menu.Target>
              <Button
                size="md"
                radius="md"
                leftIcon={<LuPlus size={16} />}
                rightIcon={<LuChevronDown size={14} />}
                className={classes.btnPrimary}
                onClick={() => setNewNoteMenuOpen((o) => !o)}
              >
                Add Note
              </Button>
            </Menu.Target>
            <Menu.Dropdown className={classes.newMenuDropdown}>
              <UnstyledButton
                className={classes.newMenuItemBtn}
                onClick={() => {
                  setNewNoteMenuOpen(false);
                  getAllStaff("all");
                  setOpen(true);
                }}
              >
                <Box className={classes.newMenuIco}>
                  <LuPlus size={16} />
                </Box>
                <Box className={classes.newMenuInfo}>
                  <Text className={classes.newMenuTitle}>Start a New Note</Text>
                </Box>
              </UnstyledButton>
              <UnstyledButton
                className={`${classes.newMenuItemBtn} ${classes.newMenuItemBordered}`}
                onClick={() => {
                  setNewNoteMenuOpen(false);
                  setPrevNoteOpened(true);
                }}
              >
                <Box className={classes.newMenuIco}>
                  <LuFileText size={16} />
                </Box>
                <Box className={classes.newMenuInfo}>
                  <Text className={classes.newMenuTitle}>Use a Previous Note</Text>
                </Box>
              </UnstyledButton>
            </Menu.Dropdown>
          </Menu>
        </Box>
      </Box>

        <Tabs.Panel value="all-notes" mt={8}>
          <Box className={classes.table}>
            <Box>
              <Input
                className={classes.searchInput}
                variant="filled"
                size="sm"
                placeholder="Search"
                icon={<IconSearch />}
                mb={10}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {hasActiveFilters && (
                <Box className={classes.activeFiltersBar} px={20} mx={20}>
                  {activeFilters.facility && (
                    <Box className={classes.filterChip}>
                      <Text size="xs">
                        Facility: {getFacilityName(activeFilters.facility)}
                      </Text>
                      <RxCross2
                        size={12}
                        onClick={() => handleRemoveFilter("facility")}
                      />
                    </Box>
                  )}
                  {activeFilters.createdBy && (
                    <Box className={classes.filterChip}>
                      <Text size="xs">
                        Staff: {getStaffName(activeFilters.createdBy)}
                      </Text>
                      <RxCross2
                        size={12}
                        onClick={() => handleRemoveFilter("createdBy")}
                      />
                    </Box>
                  )}
                  {activeFilters.noteTypeFilter && (
                    <Box className={classes.filterChip}>
                      <Text size="xs">
                        Note Type: {getNoteTypeName(activeFilters.noteTypeFilter)}
                      </Text>
                      <RxCross2
                        size={12}
                        onClick={() => handleRemoveFilter("noteTypeFilter")}
                      />
                    </Box>
                  )}
                  {dateRange && (
                    <Box className={classes.filterChip}>
                      <Text size="xs">
                        Date: {moment(dateRange[0]).format("MM/DD/YY")} -{" "}
                        {moment(dateRange[1]).format("MM/DD/YY")}
                      </Text>
                      <RxCross2
                        size={12}
                        onClick={() => handleRemoveFilter("date")}
                      />
                    </Box>
                  )}
                  <Text
                    className={classes.clearAllLink}
                    onClick={handleResetAllFilters}
                  >
                    Clear all
                  </Text>
                </Box>
              )}
              <NoteTable
                openModal={(data) => {
                  setData(data);
                  setOpen(true);
                }}
                openViewModal={(data, opts) => {
                  setData(data);
                  setHideApproveReject(!opts?.showApprovalActions);
                  setIsViewNoteOpen(true);
                }}
                onDuplicate={handleDuplicateNote}
                onEditDraft={handleEditDraft}
                onViewDraft={openDraftView}
                onDraftDeleted={refetchNotes}
                setView={(data) => {
                  setView(true);
                }}
                userId={userId}
                loading={loading}
              />
            </Box>
            <CustomPagination
              itemsPerPage={10}
              data={notes?.count}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          </Box>
        </Tabs.Panel>

        <Tabs.Panel value="drafts" pt={8}>
          <DraftNotesTab userId={userId} onEditDraft={handleEditDraft} onViewDraft={openDraftView} />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default ClientNoteview;
